/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';

import { inViewForReact } from 'utils/common';
import {
  addUnDockCandidate,
  deleteUnDockCandidate,
  deleteDockCandidate,
  closeVideoTheatre,
} from 'routes/articleshow_v2/redux';

class VideoActionController extends React.Component {
  componentDidMount() {
    if (!this.props.isTablet()) {
      window.addEventListener('scroll', this.monitorDockScroll());
    }
  }
  monitorDockScroll = () => throttle(this.handleDocking, 500);

  handleDocking = () => {
    const { dockCandidate, unDockCandidate } = this.props;
    this.lastScrollY =
      typeof this.lastScrollY === 'undefined'
        ? window.pageYOffset
        : this.lastScrollY;
    let candidate;
    if (dockCandidate && unDockCandidate) {
      candidate = dockCandidate.ref;
    } else if (dockCandidate) {
      candidate = dockCandidate.ref;
    } else if (unDockCandidate) {
      candidate = unDockCandidate.ref;
    }

    if (candidate && candidate.parentNode) {
      const vidParent = {
        node: candidate.parentNode,
        // top: candidate.parentNode.offsetTop,
        // height: candidate.parentNode.offsetHeight,
      };
      // const visiblitySkew = vidParent.offsetHeight / 3;
      if (inViewForReact(vidParent.node)) {
        this.props.deleteUnDockCandidateAction();
        //#todo: Improve the logic to delete dockCandidate on Pause

        if (this.props.loadedMiniTvComponent) {
          this.props.deleteDockCandidateAction();
        }
        // if (
        //   typeof window !== 'undefined' &&
        //   window.player &&
        //   typeof window.player.getVideoState === 'function'
        // ) {
        //   const videoState = window.player.getVideoState();
        //   if (videoState && videoState.paused) {
        //     this.props.deleteDockCandidate();
        //   }
        // }
        //add dockingCandidate, delete undockCandidate
      } else {
        this.props.closeVideoTheatre();
        //this.props.showMiniTvPlayer(false);
        this.props.addUnDockCandidateAction({ ...this.props.dockCandidate });
        //delete dockingCandidate, add undockCandidate
      }
    }
  };

  componentWillUnmount() {
    if (!this.props.isTablet()) {
      window.removeEventListener('scroll', this.monitorDockScroll());
      this.props.deleteDockCandidateAction();
      this.props.deleteUnDockCandidateAction();
    }
  }

  render() {
    return <></>;
  }
}

const mapDispatchToProps = dispatch => ({
  addUnDockCandidateAction: data => {
    dispatch(addUnDockCandidate(data));
  },
  deleteUnDockCandidateAction: () => {
    dispatch(deleteUnDockCandidate());
  },
  deleteDockCandidateAction: () => {
    dispatch(deleteDockCandidate());
  },
  closeVideoTheatre: () => {
    dispatch(closeVideoTheatre());
  },
});

const mapStateToProps = state => ({
  dockCandidate:
    typeof state.articleshow_v2 !== 'undefined'
      ? state.articleshow_v2.dockCandidate
      : undefined,
  unDockCandidate:
    typeof state.articleshow_v2 !== 'undefined'
      ? state.articleshow_v2.unDockCandidate
      : undefined,
  loadedMiniTvComponent: state.miniTv?.data?.status === '1',
});

VideoActionController.propTypes = {
  unDockCandidate: PropTypes.shape({}),
  dockCandidate: PropTypes.shape({}),
  deleteUnDockCandidateAction: PropTypes.func,
  deleteDockCandidateAction: PropTypes.func,
  addUnDockCandidateAction: PropTypes.func,
  closeVideoTheatre: PropTypes.func,
};

VideoActionController.defaultProps = {
  unDockCandidate: {
    ref: PropTypes.node,
    isLeadVideo: PropTypes.bool,
  },
  dockCandidate: {
    ref: PropTypes.node,
    isLeadVideo: PropTypes.bool,
  },
  deleteUnDockCandidateAction: () => {},
  deleteDockCandidateAction: () => {},
  addUnDockCandidateAction: () => {},
  closeVideoTheatre: () => {},
};
export default connect(mapStateToProps, mapDispatchToProps)(
  VideoActionController,
);
